import * as actionTypes from '../types/tabs';

const initialState = { tabSelect: localStorage.getItem('tabSelect') ? Number(localStorage.getItem('tabSelect')) : 0 };

const reducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case actionTypes.SET_SELECT_TAB:
      return {
        ...state,
        tabSelect: payload
      };
    default:
      return state;
  }
};

export default reducer;
